import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
    AddressInformationComponent,
    FileHandlerService,
    FileRemoverComponent,
    FileUploadComponent,
    PhoneInputComponent,
} from '@cargos/sprintpay-ui';
import { TwoFactorModule } from 'src/app/modules/two-factor/two-factor.module';
import { TwoFactorService } from 'src/app/services/requests/two-factor.service';
import { InvalidFieldComponent } from 'src/app/shared/components/invalid-field/invalid-field.component';
import { AwbSearchModule } from 'src/app/shared/modules/awb-search/awb-search.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { DynamicFileComponent } from 'src/app/standalone-components/dynamic-form-cf/dynamic-field/dynamic-file/dynamic-file.component';
import { FormPasswordComponent } from 'src/app/standalone-components/form-password/form-password.component';
import { ValidateEmailComponent } from 'src/app/standalone-components/validate-email/validate-email.component';
import { ApplyForCargoFacilityRoutingModule } from './apply-for-cargo-facility-routing.module';
import { ApplyForCargoFacilityComponent } from './apply-for-cargo-facility.component';
import { CommonSignupUploadComponent } from './common-signup-upload/common-signup-upload.component';
import { RequestReceivedComponent } from './request-received/request-received.component';
import { BusinessDetailsComponent } from './stepper/business-details/business-details.component';
import { NextPreviousButtonsComponent } from './stepper/next-previous-buttons/next-previous-buttons.component';
import { PersonalInformationComponent } from './stepper/personal-information/personal-information.component';
import { SecurityStepComponent } from './stepper/security-step/security-step.component';

@NgModule({
    declarations: [
        ApplyForCargoFacilityComponent,
        RequestReceivedComponent,
        PersonalInformationComponent,
        BusinessDetailsComponent,
        SecurityStepComponent,
        NextPreviousButtonsComponent,
        CommonSignupUploadComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        RouterModule,
        ReactiveFormsModule,
        FormsModule,
        PhoneInputComponent,
        FileUploadComponent,
        FileRemoverComponent,
        AddressInformationComponent,
        FormPasswordComponent,
        ValidateEmailComponent,
        DynamicFileComponent,
        AwbSearchModule,
        InvalidFieldComponent,
        ApplyForCargoFacilityRoutingModule,
        TwoFactorModule,
        NgOptimizedImage,
    ],
    providers: [FileHandlerService, FormGroupDirective, TwoFactorService],
})
export class ApplyForCargoFacilityModule {}
